'use strict';

import StripeCheckout from './StripeCheckout';
import stripeCheckoutRedirectHTML from './stripeCheckoutRedirectHTML';

export { StripeCheckout, stripeCheckoutRedirectHTML };
export default StripeCheckout;
